import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { PL_ROUTING } from '@common/constant';
import { delay, take } from 'rxjs/operators';

@Component({
  template: '',
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private router: Router,
    private oidcSecurityService: OidcSecurityService
  ) {}

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('code') && urlParams.get('state')) {
      this.oidcSecurityService.isAuthenticated$
        .pipe(
          delay(500), // Give the OIDC client time to process before checking auth...
          take(1)
        )
        .subscribe({
          next: () => {
            // NOTE: In all cases, whether error or not,
            // I'm opting to attempt a safe redirect to home page.
            // If they are not authenticated, they will be redirected
            // to the respective configured /login route anyway.
            // If they are authenticated, great - they can continue
            // about their business.
            this.oidcSecurityService.checkAuth().subscribe({
              next: (result) => {
                if (result.isAuthenticated) {
                  this.router.navigate([`/${PL_ROUTING.LANDING_HOME}`]);
                } else {
                  // NOTE: Authentication failed, attempt to re-authorize
                  this.oidcSecurityService.authorize();
                }
              },
              error: () => {
                this.router.navigate(['/']);
              },
            });
          },
          error: () => {
            this.router.navigate(['/']);
          },
        });
    } else {
      // NOTE: No code or state found, redirecting to root as a fallback
      this.router.navigate(['/']);
    }
  }
}
